define(function (require) {
    var avalon = require('avalon'),
        ajax = require('ajax'),
        dialog = require('dialog'),
        tool = require('toolLoaderPC'),
        orderKit;

    var hiddenValues, cancelRefundKit;

    var vmodel = avalon.define({
        $id: 'applyRefundStatusController',
        type: '', // 申请退款类型  1退款， 2 退货
        status: '', // 申请退款  1申请退款,2拒绝退款，3通过等待退款,4退款成功,5用户取消退款
        good_status: '', // 申请退货  0不退货，1申请退货，2拒绝退货，3等待收货，4退货成功
        refund_header: '',
        refund_status: [], // 申请退款信息
        expressInfo: {},

        cancelClick: function () {
            tool.singleWay(
                'mall-order-pay-refound-cancel-' + hiddenValues.refund_id,
                function (key) {
                    cancelRefundKit = this;
                    ajax
                        .postWithFail('cancel-refund.html', {
                            refund_id: hiddenValues.refund_id
                        })
                        .done(function (response) {
                            cancelRefundKit.resolve(key);

                            if (response.type === 'succ') {
                                ajax.pjax('../../order_list.html');
                            }
                        })
                        .fail(function () {
                            cancelRefundKit.resolve(key);
                        });
                }
            );
        },

        expressCompany: null,
        expressNum: null,
        expressConfig: {},
        showExpressDialog: function () {
            expressVmodel.isShowingDialog = true;
        },
        hideExpressDialog: function () {
            expressVmodel.isShowingDialog = false;
            vmodel.expressCompany = '';
            vmodel.expressNum = '';
            location.reload();
        },
        submitExpressDialog: function () {
            if (!vmodel.expressCompany || vmodel.expressCompany === '') {
                dialog.alert('请填写快递公司');
                return;
            }
            if (!vmodel.expressNum || vmodel.expressNum === '') {
                dialog.alert('请填写快递单号');
                return;
            }

            tool.singleWay(
                'mall-order-pay-refound-order-' + hiddenValues.refund_id,
                function (key) {
                    orderKit = this;
                    ajax
                        .getWithFail('save-express.html', {
                            refund_id: hiddenValues.refund_id,
                            company: vmodel.expressCompany,
                            order: vmodel.expressNum
                        })
                        .done(function (response) {
                            orderKit.resolve(key);

                            if (response.type === 'succ') {
                                dialog.alert('保存成功');
                                vmodel.hideExpressDialog();
                            }
                        })
                        .fail(function () {
                            orderKit.resolve(key);
                            vmodel.hideExpressDialog();
                        });
                }
            );
        },

        moneyClick: function () {
            ajax.jump('flow.html?refund_id=' + hiddenValues.refund_id);
        }
    });

    var expressVmodel; // 弹出层控件的vmodel
    // window.vm = vmodel
    return {
        init: function () {
            hiddenValues = tool.getHiddenValues('#js-local-hiddens');
            vmodel.expressInfo = {
                expressCompany: hiddenValues.express_company,
                expressNumber: hiddenValues.express_order,
                is: true
            };

            vmodel.refund_header = hiddenValues.refund_header;
            vmodel.refund_status = hiddenValues.refund_status;
            vmodel.type = hiddenValues.refund_status[0].type;
            vmodel.status = hiddenValues.refund_status[0].refund_status;
            vmodel.good_status =
                hiddenValues.refund_status[0].refund_goods_status;

            vmodel.expressConfig = {
                onInit: function (vm) {
                    expressVmodel = vm;
                },
                hiddenCallback: function () {
                    vmodel.hideExpressDialog();
                },
                css: {
                    width: '300px',
                    left: '50%',
                    'margin-left': '-150px',
                    padding: 0
                }
            };
        },
        clear: function () {}
    };
});



// WEBPACK FOOTER //
// ./src/js_modules/applyRefundStatusController.js